import { useState } from 'react';
import { Button } from '@design-system';
import { Pencil, ShieldCheck } from 'lucide-react';
import { usePolicyDetails } from './use-policy-details';
import { PolicyDetailsDialog } from './policy-details-dialog';
import { getPolicySummaryRows } from './policy-summary-rows';

export function GenworthPolicySummary({ client }: { client: Client }) {
  const { details } = usePolicyDetails(client.clientId);
  const [editOpen, setEditOpen] = useState(false);

  const rows = getPolicySummaryRows(details).filter(row => row.value !== undefined);
  const hasAnyDetail = rows.length > 0;

  if (!hasAnyDetail) {
    return null;
  }

  return (
    <div className="rounded-xl border p-4 md:p-6">
      <div className="mb-4 flex items-start justify-between gap-4">
        <div className="flex items-start gap-3">
          <div className="bg-primary/10 text-primary flex size-12 shrink-0 items-center justify-center rounded-md">
            <ShieldCheck className="size-5" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-gray-950">Your policy</h2>
            <p className="text-foreground text-sm">
              The coverage we walked through, all in one place.
            </p>
          </div>
        </div>
        <Button
          variant="outline"
          size="sm"
          onClick={() => setEditOpen(true)}
          data-testid="edit-policy-details-button"
        >
          <Pencil />
          Edit
        </Button>
      </div>

      <dl className="grid grid-cols-1 gap-x-10 sm:grid-cols-2">
        {rows.map(row => (
          <div
            key={row.label}
            className="border-border/60 sm:nth-last-2:border-b-0 flex items-center justify-between gap-4 border-b py-2.5 last:border-b-0"
          >
            <dt className="text-foreground text-sm">{row.label}</dt>
            <dd className="text-primary-dark text-sm font-semibold">{row.value}</dd>
          </div>
        ))}
      </dl>

      <PolicyDetailsDialog
        client={client}
        open={editOpen}
        onClose={() => setEditOpen(false)}
      />
    </div>
  );
}
